import { Editor } from "grapesjs";
declare global {
  interface Window {
    gobi: {
      discover: () => void;
      [key: string]: any;
    };
  }
}

export function gobiStory(editor: Editor) {
  editor.Blocks.add("gobi-story-block", {
    label: "Gobi",
    category: "Extras",
    media: `<i class="fa-kit fa-cs-gobi fs-2"></i>`,
    content: { type: "gobi" },
  });

  editor.DomComponents.addType("gobi", {
    model: {
      defaults: {
        script: gobiComponentScript,
        attributes: {
          "wcag-ignore": "true",
        },
        style: {
          height: "600px",
        },
        traits: [
          {
            type: "text",
            name: "source",
            label: "StoryId",
            changeProp: true,
          },
        ],
        "script-props": ["source"],
      },
      init() {
        this.listenTo(this, "change:source", this.handlePropChange);
      },
      handlePropChange() {
        this.setStyle({ height: "" });
        setTimeout(() => {
          window[1].gobi.discover();
        }, 50);
      },
    },
  });
}

const gobiComponentScript = function (props: Record<string, any>) {
  const addScript = async (src: any) =>
    new Promise((resolve, reject) => {
      const el = document.createElement("script");
      el.src = src;
      el.async = true;
      el.addEventListener("load", resolve);
      el.addEventListener("error", reject);
      document.head.append(el);
    });

  if (typeof window.gobi == "undefined") {
    addScript("https://widget.gobistories.com/gwi/6").then(() => {
      window.gobi.discover();
    });
  }

  const gobiStory = document.createElement("div");
  gobiStory.classList.add("gobi-collection");
  gobiStory.setAttribute("data-gobi-collection-id", props.source);
  // @ts-ignore
  this.appendChild(gobiStory);
};
